// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"6f886ac9","8237":"80fc467d"}[chunkId] + ".chunk.css";
};